import React, { memo } from 'react';
import { get } from 'lodash';

import { documentsSort } from '../../../service/sort';
import { AttachmentItem } from '../AttachmentItem/AttachmentItem';
import { useDocuments } from '../../../selectors/documents';
import { ContentType } from '../constants';
import { useStyles } from './useStyles';

export const AirportDocuments = memo(() => {
    const documents = useDocuments();
    const classes = useStyles();

    return (
        <>
            {documents.sort(documentsSort).map((doc) => (
                <AttachmentItem
                    key={doc.id}
                    contentType={ContentType.DOCUMENTS}
                    id={doc.id}
                    primaryText={`${doc.airport} ${doc.type}`}
                    secondaryText={doc.description}
                    isDownloaded={doc.isDownloaded}
                    download={get(doc, 'syncTime')}
                    downloadFormat="DD.MM.YYYY HH:mm"
                    downloadPreifix=""
                    className={classes.nested}
                />
            ))}
        </>
    );
});

AirportDocuments.displayName = 'AirportDocuments';
